"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateScript = exports.unitTestExports = exports.getExistingScripts = void 0;
var _utils = require("./utils");
var _log = require("./log");
var _reportError = _interopRequireDefault(require("./reportError"));
const EXACT_VERSION_CHECK_REGEX = /^\d+\.\d+\.\d+$/;
const validateScript = script => {
  var _window, _window2;
  let currentError = '';
  const localeOnPage = ((_window = window) === null || _window === void 0 ? void 0 : _window.UCMPageLocale) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scriptSupplierPageLocale);
  if (!(0, _utils.isValidString)(script === null || script === void 0 ? void 0 : script.name)) {
    currentError = 'No name was provided.';
    (0, _reportError.default)('invalidScriptNameError', currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (!(0, _utils.isValidString)(script === null || script === void 0 ? void 0 : script.version)) {
    currentError = 'No version was provided.';
    (0, _reportError.default)('invalidScriptVersionError', currentError, localeOnPage);
    throw new Error(currentError);
  }
  if (EXACT_VERSION_CHECK_REGEX.test(script.version.trim())) {
    (0, _log.logWarning)(`An exact version is configured for ${script.name}. Because of this, critical security patches 
    and bug fixes won't be applied. It's unlikely this is intentional. It's recommended to use a range like "^1.0.0".`);
  }
  if (script.version.trim() === '*') {
    (0, _log.logWarning)(`A star version range is used for ${script.name}. This is not recommended, as breaking changes will
    automatically be applied, increasing the risk of a production issue. It's recommended to use a range like "^1.0.0" instead.`);
  }
};
exports.validateScript = validateScript;
const getExistingScripts = () => {
  return document.querySelectorAll('script');
};
exports.getExistingScripts = getExistingScripts;
const unitTestExports = {
  EXACT_VERSION_CHECK_REGEX
};
exports.unitTestExports = unitTestExports;